module.exports = __webpack_public_path__ + "img/support.a29973cf.svg";